import { usePortalAuth } from '@nrx/auth/react';
import type { JSX } from 'react';

/**
 * LogoutComplete — rendered at /auth/logout after the Hosted UI logout redirect.
 * Provides a branded "signed out" confirmation with a sign-in again link.
 */
export function LogoutComplete(): JSX.Element {
  const auth = usePortalAuth();

  function handleSignIn(): void {
    void auth.signinRedirect();
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-900">You have been signed out</h1>
        <p className="mt-2 text-gray-600">Your session has ended securely.</p>
        <button
          onClick={handleSignIn}
          className="mt-6 rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          Sign in again
        </button>
      </div>
    </div>
  );
}
